export class GlobalSearchModel{
    searchText:string;
    searchFor:string;
    branchId:number;
}